import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

export interface RaceItem {
    raceresult_id?: number,
    raceday_id?: number,
    player_id?: number,
    name_gt7?: string,
    name_psn?: string,
    car_id?: number,
    car_name?: string,
    position_finished?: number,
    position_clean?: number,
    best_lap?: string,
    final_time?: string,
    status?: string,
}

export interface IncidentItem {
    raceincident_id?: number,
    raceday_id?: number,
    player_id?: number,
    name_gt7?: string,
    name_psn?: string,
    incident?: string,
    description?: string,
    active?: number,
}

export interface RaceDaysItem {
    raceday_id?: number;
    group_id?: number;
    group_name?: string;
    circuit_id?: number;
    circuit_name?: string;
    circuit_icon?: string;
    circuit_location?: string;
    day_real?: string;
    races?: RaceItem[];
    incidents?: IncidentItem[];
}

export interface RaceDaysTableItem {
    raceday_id?: number;
    season_id?: number;
    group_id?: string;
    circuit_id?: number;
    day_planned?: string;
    day_real?: string;
    circuit_icon_small?: string;
}

export interface Race {
    day_id: string,
    points_v1?: number
    points_v2?: number
    points_v3?: number
}

export interface LeagueItem {
    player_id?: number,
    name_psn?: string,
    name_gt7?: string,
    car_id?: number,
    car_name?: string,
    status?: string,
    races?: Race[],
    points_total?: number,
    final_position?: number,
    average_points_v3?: number,
}

export interface IncidentPointsItem {
    player_id: number;
    raceday_id: number;
    day_real: string;
    penalty_total: number;
}

@Injectable()
export class RacesService {
    private apiRacesGetRaceDaysUrl = `${environment.apiBaseUrl}/api/racesGetDaysForSeason.php`;
    private apiRacesGetRaceDaysV2Url = `${environment.apiBaseUrl}/api/racesGetDaysForSeasonV2.php`;
    private apiGetLeagueTableUrl = `${environment.apiBaseUrl}/api/racesGetLeagueTableForSeason.php`;
    private apiGetLeagueTableV2Url = `${environment.apiBaseUrl}/api/racesGetLeagueTableForSeasonV2.php`;
    private apiGetLeagueTableV3Url = `${environment.apiBaseUrl}/api/racesGetLeagueTableForSeasonV3.php`;
    private apiGetRaceDaysUrl = `${environment.apiBaseUrl}/api/raceDays.php`;
    private apiRacesGetTotalPointsForSeasonV3Url = `${environment.apiBaseUrl}/api/racesGetTotalPointsForSeasonV3.php`;
    private apiGetIncidentsForSeasonUrl = `${environment.apiBaseUrl}/api/racesGetIncidentsForSeason.php`;

    constructor(private http: HttpClient) {}

    getDaysForSeason(season: string, group: string): Observable<RaceDaysItem[]> {
        const params = new HttpParams().set('season', season).set('group', group);
        return this.http.get<RaceDaysItem[]>(this.apiRacesGetRaceDaysUrl, { params });
    }    
    getDaysForSeasonV2(season: string): Observable<RaceDaysItem[]> {
        const params = new HttpParams().set('season', season);
        return this.http.get<RaceDaysItem[]>(this.apiRacesGetRaceDaysV2Url, { params });
    }

    getLeagueTableForSeason(season: string, group: string): Observable<LeagueItem[]> {
        const params = new HttpParams().set('season', season).set('group', group);
        return this.http.get<LeagueItem[]>(this.apiGetLeagueTableUrl, { params });
    }

    getLeagueTableForSeasonV2(season: string): Observable<LeagueItem[]> {
        const params = new HttpParams().set('season', season);
        return this.http.get<LeagueItem[]>(this.apiGetLeagueTableV2Url, { params });
    }

    getLeagueTableForSeasonV3(season: string): Observable<LeagueItem[]> {
        const params = new HttpParams().set('season', season);
        return this.http.get<LeagueItem[]>(this.apiGetLeagueTableV3Url, { params });
    }

    getRaceDays(season: string, group: string): Observable<RaceDaysTableItem[]> {
        const params = new HttpParams().set('season', season).set('group', group);
        return this.http.get<RaceDaysTableItem[]>(this.apiGetRaceDaysUrl, { params });
    }

    getTotalPointsForSeasonV3(season: string): Observable<any> {
        const params = new HttpParams().set('season', season);
        return this.http.get<any>(this.apiRacesGetTotalPointsForSeasonV3Url, { params });
    }

    getIncidentsForSeason(season: string): Observable<IncidentPointsItem[]> {
        const params = new HttpParams().set('season', season).set('_', String(Date.now()));
        return this.http.get<IncidentPointsItem[]>(this.apiGetIncidentsForSeasonUrl, { params });
    }
}
